<div class="container-fluid g-0">
  <div class="row g-0">
    <div class="col-5 left-image">
      <img src="assets/core/login/login.svg" class="full-height" alt="Login"/>
    </div>
    <div class="col d-flex justify-content-center align-items-center">
      <div class="right-content">
        <svg-icon alt="Adora Logo" src="assets/core/login/adora_AMI.svg" class="adora-img"></svg-icon>
        <h3 class="title mb-5 mt-3">Welcome to Adora Headend System</h3>
        <h6 class="subtitle">
          Our Headend System is an advanced platform designed to seamlessly
          collect, aggregate, and integrate data from a variety of meters within
          your network. By capturing real-time metrics and continuously
          monitoring for anomalies, it ensures that all data remains accurate,
          up-to-date, and readily available for in-depth analysis. The system
          also provides comprehensive alarm management capabilities, empowering
          you to promptly respond to critical events.
          With powerful analytics and efficient data flow, our system optimizes
          the performance and operational efficiency of your entire
          infrastructure, ensuring smooth and reliable operations at all times.
        </h6>
        <div class="row-0 d-flex justify-content-center button-container">
          <button class="add" type="submit" (click)="login()">Login</button>
        </div>
      </div>
    </div>
  </div>